import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import MessageTextSquareIcon from '~/assets/icons/new/message-text-square-01.svg?react';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';

import useFeedbackNavStyles from './FeedbackNavItem.styles';

const TRANSLATION_KEYS = {
  giveFeedback: 'feedback:cta.giveFeedback',
} as const;

export type FeedbackNavItemProps = {
  isNavDrawerOpen: boolean;
  onOpen: () => void;
};

/**
 * Sidebar control that opens the feedback dialog; aligned with nav row visuals via theme.new.
 */
const FeedbackNavItem = ({
  isNavDrawerOpen,
  onOpen,
}: FeedbackNavItemProps): JSX.Element => {
  const { classes } = useFeedbackNavStyles({
    isIconOnly: !isNavDrawerOpen,
  });
  // Subscribe to locale changes while keeping fully-qualified keys (same as
  // translateText / ChoosePlanStep) so copy still resolves if the `feedback`
  // namespace is not the hook default.
  useTranslation();
  const label = translateText(TRANSLATION_KEYS.giveFeedback);

  return (
    <button
      type="button"
      onClick={onOpen}
      className={classes.root}
      data-testid="feedback-cta-button"
      id="nav-feedback-item"
      aria-label={isNavDrawerOpen ? undefined : label}
    >
      <span className={classes.itemIcon}>
        <MessageTextSquareIcon width={24} height={24} aria-hidden />
      </span>
      {isNavDrawerOpen && (
        <Typography variant="body_medium" className={classes.itemText}>
          {label}
        </Typography>
      )}
    </button>
  );
};

export default FeedbackNavItem;
